const colors = {
  brand: {},
  gray: {
    50: '#F8FAFC',
    100: '#F2F5F7',
    200: '#E7EBEF',
    300: '#C2D4DB',
    400: '#93AFB9',
    500: '#4F6F7B',
    600: '#346071',
    700: '#04475C',
    800: '#012E47',
    900: '#00243A',
  },
  red: {
    50: '#F8DFE6',
    100: '#FFE8ED',
    200: '#FFC7D3',
    300: '#FF859E',
    400: '#FF597B',
    500: '#FF214E',
    600: '#D81A40',
    700: '#B11333',
    800: '#8A0D26',
    900: '#630619',
  },
  yellow: {
    50: '#FCF8E3',
    100: '#FFF7E5',
    200: '#FFECBF',
    300: '#FFD573',
    400: '#FFC640',
    500: '#FFB300',
    600: '#DD9B00',
    700: '#B67A01',
    800: '#935F00',
    900: '#704500',
  },
  blue: {
    50: '#D9EDF7',
    100: '#E5F1FF',
    200: '#C6DEFE',
    300: '#78B2FF',
    400: '#4490FD',
    500: '#0076FF',
    600: '#005BC4',
    700: '#0051B4',
    800: '#003E8F',
    900: '#002A6A',
  },
  green: {
    50: '#CCFFE6',
    100: '#CCFFE6',
    200: '#9CF6CE',
    300: '#69E6AF',
    400: '#33D890',
    500: '#00C66F',
    600: '#079072',
    700: '#00804E',
    800: '#005E3A',
    900: '#003B27',
  },
  primary: {
    50: '#D9EDF7',
    100: '#E5F1FF',
    200: '#C6DEFE',
    300: '#78B2FF',
    400: '#4490FD',
    500: '#0076FF',
    600: '#005BC4',
    700: '#0051B4',
    800: '#003E8F',
    900: '#002A6A',
  },
  secondary: {
    50: '#CCFFE6',
    100: '#CCFFE6',
    200: '#9CF6CE',
    300: '#69E6AF',
    400: '#33D890',
    500: '#00C66F',
    600: '#079072',
    700: '#00804E',
    800: '#005E3A',
    900: '#003B27',
  },
};

export default colors;
